import CallApp from '@zz-common/call-app'
import { lego } from '@zz-common/lego'
import { debounce } from 'lodash-es'

const ua = (window.navigator && window.navigator.userAgent) || ''
const platform = (window.navigator && window.navigator.platform) || ''
const isSafari = /Safari\//i.test(ua)
console.log('ua:', ua)
console.log('platform:', platform)

/**
 * 获取url中query参数
 * @param {*参数名} name
 */
export const getQueryStringBySearch = (name) => {
  try {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
    const r = window.location.search.substr(1).match(reg)
    // decode query
    if (r != null) return decodeURIComponent(r[2])
  } catch (error) {
    return ''
  }
  return ''
}

export const getQueryStringByHash = (name) => {
  try {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
    const r = window.location.hash.replace(/^#\/?\??/, '').match(reg)
    // decode query
    if (r != null) return decodeURIComponent(r[2])
  } catch (error) {
    return ''
  }
  return ''
}

export const getQueryString = (name) =>
  getQueryStringBySearch(name) || getQueryStringByHash(name);

console.log('window.location.search', window.location.search)
console.log('window.location.hash', window.location.hash)

/*******    ********/

export const callApp = new CallApp()
// 打开 devLogInfo
window.__callAppDev__ = true

//
const isSchemePrefix = (path) => /^(zhuanzhuan:\/\/)|(zljgo:\/\/)|(zzhunter:\/\/)|(weixin:\/\/)/i.test(path)
const isHttpPrefix = (path) => /^https?:\/\//.test(path)
// path 或 url 参数 支持直接传入 m 页 http url
const wrapHttpPath2SchemeUrl = (path = 'https://m.zhuanzhuan.com?a=1', app) => {
  // 不同目标 app 对应 不同对 wrap 方法
  switch (app) {
    case targetAppMap.ZZ:
      return `zhuanzhuan://jump/core/web/jump?url=${encodeURIComponent(path)}`;
    case targetAppMap.ZLJ:
      return `zljgo://native_api?type=1&content=${encodeURIComponent(path)}`;
    case targetAppMap.HUNTER:
      return `zzhunter://jump/core/web/jump?url=${encodeURIComponent(path)}`;
    default:
      return `zhuanzhuan://jump/core/web/jump?url=${encodeURIComponent(path)}`;
  }
}
//
const transApp2TargetApp = (app) => {
  switch (app) {
    case targetAppMap.ZZ:
      return 'zz'
    case targetAppMap.ZLJ:
      return 'zlj'
    case targetAppMap.HUNTER:
      return 'zzHunter'
    case targetAppMap.WXMini:
      return 'wxMini'
    default:
      return 'zz'
  }
}
// 兼容处理修复  zhuanzhuan:/jump/ => zhuanzhuan://jump/
const hackFixPath = path => {
  if (/zhuanzhuan:\/jump\//i.test(path)) {
    return path.replace('zhuanzhuan:/jump/', 'zhuanzhuan://jump/')
  }
  if (/zljgo:\/native_api/i.test(path)) {
    return path.replace('zljgo:/native_api', 'zljgo://native_api')
  }
  if (/zzhunter:\/jump\//i.test(path)) {
    return path.replace('zzhunter:/jump/', 'zzhunter://jump/')
  }
  return path
}
//
const handleDownload = () => {
  const url = getQueryString('url') || ''
  const channelId = getQueryString('channelId') || ''
  const openType = getQueryString('openType') || 'home'
  const id = getQueryString('id') || ''
  const isAutoDownload = getQueryString('isAutoDownload') || 1
  const isOpen = getQueryString('isOpen') || ''
  const deeplinkId = getQueryString('deeplinkId') || ''
  const delayTime = getQueryString('delayTime') || ''
  let path = getQueryString('path') || ''
  const app = getQueryString('app') || 'zz'
  const targetApp = transApp2TargetApp(app)

  console.log(app, path, url, channelId, deeplinkId)

  let options = {}

  if (!path && !url && !getQueryString('openType')) {
    console.log('path or url is undefined, goto download', { targetApp, channelId, deeplinkId })
    callApp.download({ targetApp, channelId, deeplinkId })
    return
  }

  if (path) {
    path = hackFixPath(path);
    console.log('hackFixPath', path);

    if (isSchemePrefix(path)) {
      options = { path, channelId, deeplinkId, targetApp: targetApp }
    } else if (isHttpPrefix(path)) {
      const uri = wrapHttpPath2SchemeUrl(path, app)
      options = { path: uri, channelId, deeplinkId, targetAPP: targetApp }
    } else {
      console.error('url params path is invalid')
      options = { path: wrapHttpPath2SchemeUrl(undefined, app) }
    }
  } else if (url) {
    const uri = wrapHttpPath2SchemeUrl(url, app)
    options = { path: uri, channelId, deeplinkId, targetAPP: targetApp }
  } else if (openType) {
    // 兼容旧 方式
    const urlSearch = {
      openType: openType,
      id: id,
    }

    options = { channelId, urlSearch: urlSearch, delay: 1600, deeplinkId }
  }

  if (delayTime) {
    options.delay = +delayTime || 3000
  }
  // 不支持 universal-link 才会落地到 mjump.zhuanzhuan.com ,
  // isSafari 解决客户端app 注册 ulink 异常 bug
  if (isSafari || /mjump\.zhuanzhuan\.com/.test(window.location.host)) {
    options.universal = false
  } else {
    options.universal = true
  }

  // 2021.09.14 采货侠 目前不支持 universal-link
  if (isChxDownload) options.universal = false

  options = Object.assign(
    {
      download: isAutoDownload == 1,
      universal: isOpen != 1,
      callStart() {
        lego.send({
          actiontype: 'DOWNLOADREQ-START',
          pagetype: 'ZZDOWNLOADH5',
          backup: { channelId, deeplinkId, app, platform },
        })
        console.log('ZZDOWNLOADH5 callStart')
      },
      callSuccess() {
        lego.send({
          actiontype: 'DOWNLOADREQ-SUCCESS',
          pagetype: 'ZZDOWNLOADH5',
          backup: { channelId, deeplinkId, app, platform },
        })
        console.log('ZZDOWNLOADH5 callSuccess')
      },
      callFailed() {
        lego.send({
          actiontype: 'DOWNLOADREQ-FAILED',
          pagetype: 'ZZDOWNLOADH5',
          backup: { channelId, deeplinkId, app, platform },
        })
        console.log('ZZDOWNLOADH5 callFailed')
      },
      callDownload() {
        lego.send({
          actiontype: 'DOWNLOADREQ-DOWNLOAD',
          pagetype: 'ZZDOWNLOADH5',
          backup: { channelId, deeplinkId, app, platform },
        })
        console.log('ZZDOWNLOADH5 callDownload')
      }
    },
    options
  )

  console.log('-- options --', options)

  lego.send({
    actiontype: 'DOWNLOADREQ',
    pagetype: 'ZZDOWNLOADH5',
    backup: { channelId, deeplinkId, app, platform },
  })

  callApp.start(options)
}

export const initDownload = () => {
  if (getQueryString('isOpen') == 1) {
    handleDownload()
  }

  const channelId = getQueryString('channelId') || ''
  const deeplinkId = getQueryString('deeplinkId') || ''
  const app = getQueryString('app') || 'zz'

  lego.send({
    actiontype: 'PAGESHOW',
    pagetype: 'ZZDOWNLOADH5',
    backup: { channelId, deeplinkId, app, platform },
  })
}

export const initPage = (buttonId) => {
  const btn = document.querySelector(buttonId)

  btn.addEventListener(
    'click',
    debounce(() => handleDownload(), 300),
    false
  )
}

/*****   ******/
// 根据 path 判断唤起的 app
export const handlePath2App = (appPath) => {
  return window.location.pathname.includes(appPath)
}

const targetAppMap = {
  ZZ: 'zz',
  ZLJ: 'zlj',
  HUNTER: 'hunter',
  WXMini: 'wxMini'
}
// 转转
export const isZZDownload = getQueryString('app') == targetAppMap.ZZ
// 找靓机
export const isZljDownload = getQueryString('app') == targetAppMap.ZLJ
// 采货侠
export const isChxDownload = getQueryString('app') == targetAppMap.HUNTER
// 微信小程序
export const isWXMini = getQueryString('app') == targetAppMap.WXMini
